<template>
  <v-checkbox
    ref="checkbox"
    v-bind="{ ...$props, ...$attrs }"
    @update:model-value="change"
  />
</template>
<script>
export default {
  name: 'DpplCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:model-value'],
  data() {
    return {
      checked: this.modelValue,
    };
  },
  methods: {
    change() {
      this.checked = !this.checked;
      this.$emit('update:model-value', this.checked);
    },
  },
};
</script>

<style scoped lang="less">
:deep(.v-label) {
  opacity: 1;
  color: @text-darkest;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
}

:deep(.v-selection-control--error:not(.v-selection-control--disabled) .v-label) {
  color: @red-700;
}
</style>
